<template>
  <div>
    <my-header/>

    <div class="regatta-box">

      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'regatta_list'}">Регаты</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Регата {{ regattaId }}</h2>

      <div class="section-container">
        <side-nav :menuItems="menuItems" class="side-nav"></side-nav>

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

export default {
  name: 'Regatta',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    regattaId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Информация',
          route: {name: 'regatta_info'},
          exact: true,
        },
        {
          title: 'Rounds',
          route: {name: 'regatta_rounds'},
        },
      ];
      return items;
    },
  },
};
</script>

<style scoped>
.regatta-box {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2em;
  background-color: rgb(242, 247, 251);
}

.content-box {
  width: 100%;
}
</style>
